import {
  createSlice,
  PayloadAction,
  Slice,
  CaseReducerActions,
  SliceCaseReducers,
  AnyAction,
} from "@reduxjs/toolkit";
import { Reducer } from "react";
import { RootState, AppThunk } from ".";
import {
  ProaService,
  IProaService,
} from "../services/proyecta/proa-form.service";
import { Utilities } from "@utils";
import {
  ICmdBasicDataProjectProa,
  ProaTablaInSections,
  ICmdBasicDataProjectProaFRYSPC,
  IProaDetailImpl,
} from "@models/";

export interface IProaState {
  formMasters: any;
  dataProaForm: any;
  basebudget: any;
  basicBudgets?: any[];
  projectNumber?: any;
  currentProa?: any;
  currentDatosBasicos?: any;
  steps: {};
  projectCode?: any;
  budget?: any;
  currentBudget?: any; //En uso
  currentBudgetDetails?: any; //En uso
  subProjectsInfo?: any; //En uso
  projectsGrouped?: any; //En uso
  detailDataBudget?: any;
  basicDataColumns?: any;
  detailDataColumns?: any;
  summaryData?: any;
  allSummaryData?: any;
  budgetsData?: any;
  csvByCountryData?: any;
  csvByOnData?: any;
  resumeBudgetDataColumns?: any;
  formBudgetByProjectTableColumnDefinition?: any;
  formBudgetTablesFFCCColumnDefinition?: any;
  localPartners: any;
  columnsDefinitions: any;
  locations: any;
  summaryDataFields: any;
  dataFFRR: any;
  dataSPC: any;
  dataProjectBeneficiary: any;
  dataFRYSPC: any;
  dataTableProaBaseLine: any;
  dataTableProaBenefic: any;
  stategicLine?: any;
  currentbasicData?: any;
  currentBudgetStartDate?: any;
  formState?: any;
  beneficiariesDuplicates?: any;
}

export class ProaStore {
  reducer: Reducer<any, AnyAction>;
  service: IProaService;
  initialState: IProaState;
  initialDeatailState: any;
  slice: Slice;
  actions: CaseReducerActions<SliceCaseReducers<any>>;

  //declare selectors
  selectText: any;
  selectProaBasicDataColumnDefinition: any;
  selectFormMasters: any;
  selecBasebudget: any;
  selectBasicBudgets: any;
  selectProjectNumber: any;
  selectCurrentProa: any;
  selecValidationSteps: any;
  selectCurrentDatosBasicos: any;
  selectsummaryDataFields: any;
  selectSummaryData: any;
  selectAllSummaryData: any;
  selectBudgetsData: any;
  selectDataFFRR: any;
  selectDataSPC: any;
  selectDataProjectBeneficiary: any;
  selectDataFRYSPC: any;
  selectDataTableProaBaseLine: any;
  selectDataTableProaBenefic: any;
  selectDetailDataBudget: any;
  selectStategicLine: any;

  selectValidatorSteps: any;
  selectLocalPartners: any;
  selectDataSteps: any;

  //Proa-location
  selectColumnsDefinition: any;
  selectLocations: any;
  selectCurrentbasicData: any;

  //Tavo
  selectCurrentBudget: any;
  selectCurrentBudgetDetails: any;
  selectCurrentBudgetStartDate: any;
  selectFormState: any;
  selectSubProjectsInfo: any;
  selectProjectsGrouped: any;

  // Superposición Beneficiarios
  selectBeneficiariesDuplicates: any;

  constructor() {
    this.proa();
  }

  //#region Private Methods
  private proa() {
    this.service = new ProaService();
    this.initialState = this.stateInit();
    this.slice = createSlice({
      name: "proa",
      initialState: this.initialState,
      reducers: this.reducersInit(),
    });

    //create properties to context - redux actions & redux reducer
    this.actions = this.slice.actions;
    this.reducer = this.slice.reducer;
    //initialize selectors
    this.selectorsInit();
  }

  private reducersInit() {
    return {
      getAllFormMasters: (state: IProaState, action: PayloadAction<any>) => {
        state.formMasters = action.payload;
      }, //En uso
      getProaDataForm: (state: IProaState, action: PayloadAction<any>) => {
        state.dataProaForm = action.payload;
      },
      getProaDataBaseLine: (state: IProaState, action: PayloadAction<any>) => {
        state.dataTableProaBaseLine = action.payload;
      },
      getProaDataBenefic: (state: IProaState, action: PayloadAction<any>) => {
        state.dataTableProaBenefic = action.payload;
      },
      getProaDataPresupuesto: (
        state: IProaState,
        action: PayloadAction<any>
      ) => {
        state.basebudget = action.payload;
      },
      getBasicBudgets: (state: IProaState, action: PayloadAction<any>) => {
        state.basicBudgets = action.payload;
      },
      setCurrentBudget: (state: IProaState, action: PayloadAction<any>) => {
        state.currentBudget = action.payload;
      }, //En uso
      setCurrentBudgetDetails: (
        state: IProaState,
        action: PayloadAction<any>
      ) => {
        state.currentBudgetDetails = action.payload;
      }, //En uso
      setSubProjectsInfo: (state: IProaState, action: PayloadAction<any>) => {
        state.subProjectsInfo = action.payload;
      }, //En uso
      setProjectsGrouped: (state: IProaState, action: PayloadAction<any>) => {
        state.projectsGrouped = action.payload;
      }, //En uso
      setCurrentDatosBasicos: (
        state: IProaState,
        action: PayloadAction<any>
      ) => {
        state.currentDatosBasicos = action.payload;
      },
      setCurrentBudgetStartDate: (
        state: IProaState,
        action: PayloadAction<any>
      ) => {
        state.currentBudgetStartDate = action.payload;
      },
      getProjectNumber: (state: IProaState, action: PayloadAction<any>) => {
        state.projectNumber = action.payload;
      },
      getProjectByGrantCodeId: (
        state: IProaState,
        action: PayloadAction<any>
      ) => {
        state.formMasters.projects = action.payload;
      },
      validatorSteps: (state: IProaState, action: PayloadAction<any>) => {
        state.steps = action.payload;
      },
      getAllColumnsDefinition: (
        state: IProaState,
        action: PayloadAction<any>
      ) => {
        state.columnsDefinitions = action.payload;
      },
      setLocations: (state: IProaState, action: PayloadAction<any>) => {
        state.locations = action.payload;
      },
      setLocalPartners: (state: IProaState, action: PayloadAction<any>) => {
        state.localPartners = action.payload;
      },

      setCurrentBasicData: (state: IProaState, action: PayloadAction<any>) => {
        state.currentbasicData = action.payload;
      },
      setSummaryFieldsDefinition: (
        state: IProaState,
        action: PayloadAction<any>
      ) => {
        state.summaryDataFields = action.payload;
      },
      setProaSummary: (state: IProaState, action: PayloadAction<any>) => {
        state.summaryData = action.payload;
      },
      setAllProaSummary: (state: IProaState, action: PayloadAction<any>) => {
        state.allSummaryData = action.payload;
      },
      getDataFFRR: (state: IProaState, action: PayloadAction<any>) => {
        state.dataFFRR = action.payload;
      },
      setProaBudgets: (state: IProaState, action: PayloadAction<any>) => {
        state.budgetsData = action.payload;
      },
      setBeneficiariesDuplicates: (state: IProaState, action: PayloadAction<any>) => {
        state.beneficiariesDuplicates = action.payload;
      },
      getDataSPC: (state: IProaState, action: PayloadAction<any>) => {
        state.dataSPC = action.payload;
      },
      getDataProjectBeneficiary: (
        state: IProaState,
        action: PayloadAction<any>
      ) => {
        state.dataProjectBeneficiary = action.payload;
      },
      setDataFRYSPC: (state: IProaState, action: PayloadAction<any>) => {
        state.dataFRYSPC = action.payload;
      },
      getDetailDataBudget: (state: IProaState, action: PayloadAction<any>) => {
        state.detailDataBudget = action.payload;
      },
      getStrategicLinesByidBudget: (
        state: IProaState,
        action: PayloadAction<any>
      ) => {
        state.stategicLine = action.payload;
      },
      setFormState: (state: IProaState, action: PayloadAction<any>) => {
        state.formState = action.payload;
      },
    };
  }

  private selectorsInit() {
    this.selectProaBasicDataColumnDefinition = (state: RootState) =>
      state.proa.dataProaForm;
    this.selectFormMasters = (state: RootState) => state.proa.formMasters;
    this.selecBasebudget = (state: RootState) => state.proa.basebudget;
    this.selectProjectNumber = (state: RootState) => state.proa.projectNumber;
    this.selectCurrentProa = (state: RootState) => state.proa.currentProa;
    this.selectBasicBudgets = (state: RootState) => state.proa.basicBudgets;
    this.selectCurrentDatosBasicos = (state: RootState) =>
      state.proa.currentDatosBasicos;
    this.selecValidationSteps = (state: RootState) => state.proa.validatorSteps;
    this.selectColumnsDefinition = (state: RootState) =>
      state.proa.columnsDefinitions;
    this.selectLocalPartners = (state: RootState) => state.proa.socialPartners;
    this.selectDataSteps = (state: RootState) => state.proa.steps;
    this.selectCurrentbasicData = (state: RootState) =>
      state.proa.currentbasicData;
    this.selectsummaryDataFields = (state: RootState) =>
      state.proa.summaryDataFields;
    this.selectSummaryData = (state: RootState) => state.proa.summaryData;
    this.selectAllSummaryData = (state: RootState) => state.proa.allSummaryData;
    this.selectBudgetsData = (state: RootState) => state.proa.budgetsData;
    this.selectDataFFRR = (state: RootState) => state.proa.dataFFRR;
    this.selectDataSPC = (state: RootState) => state.proa.dataSPC;
    this.selectDataProjectBeneficiary = (state: RootState) =>
      state.proa.dataProjectBeneficiary;
    this.selectDataFRYSPC = (state: RootState) => state.proa.dataFRYSPC;
    this.selectDataTableProaBaseLine = (state: RootState) =>
      state.proa.dataTableProaBaseLine;
    this.selectDataTableProaBenefic = (state: RootState) =>
      state.proa.dataTableProaBenefic;
    this.selectDetailDataBudget = (state: RootState) =>
      state.proa.detailDataBudget;
    this.selectStategicLine = (state: RootState) => state.proa.stategicLine;
    this.selectCurrentBudget = (state: RootState) => state.proa.currentBudget; //En Uso
    this.selectSubProjectsInfo = (state: RootState) => state.proa.subProjectsInfo; //En Uso
    this.selectProjectsGrouped = (state: RootState) => state.proa.projectsGrouped; //En Uso
    this.selectCurrentBudgetDetails = (state: RootState) =>
      state.proa.currentBudgetDetails; //En Uso
    this.selectCurrentBudgetStartDate = (state: RootState) =>
      state.proa.currentBudgetStartDate; //En Uso
    this.selectFormState = (state: RootState) => state.proa.formState; //En Uso
    this.selectBeneficiariesDuplicates = (state: RootState) => state.proa.beneficiariesDuplicates; //En Uso
  }

  private stateInit() {
    let state: IProaState = {
      formMasters: null,
      dataProaForm: null,
      basebudget: null,
      basicBudgets: [],
      projectNumber: null,
      currentProa: null,
      currentDatosBasicos: null,
      steps: {},
      projectCode: null,
      budget: null,
      currentBudget: null,
      subProjectsInfo: null,
      projectsGrouped: null,
      basicDataColumns: null,
      detailDataColumns: null,
      summaryData: null,
      allSummaryData: null,
      csvByCountryData: null,
      csvByOnData: null,
      resumeBudgetDataColumns: null,
      formBudgetByProjectTableColumnDefinition: null,
      formBudgetTablesFFCCColumnDefinition: null,
      columnsDefinitions: null,
      locations: null,
      localPartners: null,
      summaryDataFields: null,
      dataFFRR: null,
      dataSPC: null,
      dataProjectBeneficiary: null,
      dataFRYSPC: null,
      dataTableProaBaseLine: null,
      dataTableProaBenefic: null,
      formState: [],
      beneficiariesDuplicates: []
    };
    return state;
  }

  //#endregion

  public getAllFormMasters = (): AppThunk => (dispatch, getState) => {
    const lang = getState().session.lang;
    if (!Utilities.isNullObject(lang)) {
      this.service
        .getAllFormMasters(lang.label)
        .then((formMaster: any) => {
          dispatch(this.actions.getAllFormMasters(formMaster));
        })
        .catch((err) => Utilities.writeInConsoleLog(err));
    }
  };
  //En Uso

  /**
   * getProaSummary: Obtiene la data para pintar los datos de proa debajo de las columnas
   * @dispatch: Despachador
   * @getState: Funcion que obtiene la data
   * @return: Void
   */
  public getProaSummary = (): AppThunk => (dispatch, getState) => {
    const lang = getState().session.lang;
    if (!Utilities.isNullObject(lang)) {
      this.service
        .getProaSummary(lang.label)
        .then((summaryData: any) => {
          dispatch(this.actions.setProaSummary(summaryData));
        })
        .catch((err) => {
          Utilities.writeInConsoleLog(err);
        });
    }
  };

  public getAllProaSummary = (): AppThunk => (dispatch, getState) => {
    const lang = getState().session.lang;
    if (!Utilities.isNullObject(lang)) {
      this.service
        .getAllProaSummary()
        .then((summaryData: any) => {
          dispatch(this.actions.setAllProaSummary(summaryData));
        })
        .catch((err) => {
          Utilities.writeInConsoleLog(err);
        });
    }
  };

  public getProaBudget = (): AppThunk => (dispatch, getState) => {
      this.service
        .getAllBudgetsByProject()
        .then((proaBudget: any) => {
          dispatch(this.actions.setProaBudgets(proaBudget));
        })
        .catch((err) => {
          Utilities.writeInConsoleLog(err);
        });
  };

  //En uso Tavo
  public getBudget = (budgetId: number): AppThunk => (dispatch) => {
    this.service
      .getBudget(budgetId)
      .then((budget: any) => {
        dispatch(this.actions.setCurrentBudget(budget));
      })
      .catch((err) => Utilities.writeInConsoleLog(err));
  };
  public getBudgetDetails = (budgetId: number): AppThunk => (dispatch) => {
    this.service
      .getBudgetDetails(budgetId)
      .then((details: any) => {
        dispatch(this.actions.setCurrentBudgetDetails(details));
      })
      .catch((err) => Utilities.writeInConsoleLog(err));
  };
  public getSubProjectsInfo = (budgetId: number): AppThunk => (dispatch) => {
    this.service
      .getSubProjectsInfo(budgetId)
      .then((SubProjectsInfo: any) => {
        dispatch(this.actions.setSubProjectsInfo(SubProjectsInfo || []));
      })
      .catch((err) => Utilities.writeInConsoleLog(err));
  };
  public getProjectsGrouped = (budgetId: number): AppThunk => (dispatch) => {
    this.service
      .getProjectsGrouped(budgetId)
      .then((ProjectsGrouped: any) => {
        dispatch(this.actions.setProjectsGrouped(ProjectsGrouped || []));
      })
      .catch((err) => Utilities.writeInConsoleLog(err));
  };
  //#endregion
}
